import * as React from "react";
import { forwardRef } from "react";

import DeprecatedIconButton from "@v1/components/designSystem/button/IconButton";
import DynamicData from "@v1/svg/dynamic-data";

type DynamicDataButtonProps = {
  tooltipText?: string;
} & React.ComponentPropsWithoutRef<"button">;

const DynamicDataButton = forwardRef<HTMLButtonElement, DynamicDataButtonProps>(
  ({ onClick, tooltipText = "Add Dynamic Data" }, ref) => {
    return (
      <DeprecatedIconButton
        ref={ref}
        type="button"
        size="sm"
        variant="secondary"
        onClick={onClick ?? undefined}
        icon={<DynamicData />}
        tooltipText={tooltipText}
      />
    );
  },
);

DynamicDataButton.displayName = "DynamicDataButton";

export default DynamicDataButton;
